import { takeEvery, put } from 'redux-saga/effects'
import {
  VEHICLE_REFERENCE_PARAMETERS_SAVED,
  getTruckDetails,
} from 'actions/truck'
import { createSystemNotification } from 'actions/application'
import { CLEAR_PIN_ASSIGNMENTS } from 'actions/ctp.js'
import strings from 'utils/strings'

/**
 * Watcher saga — reacts to a successful vehicle reference parameter save.
 *
 * When `saveVehicleReferenceParameters` completes successfully, the apiCall
 * saga dispatches `VEHICLE_REFERENCE_PARAMETERS_SAVED`. This saga then:
 *   1. Shows the "Vehicle updated" success toast notification.
 *   2. Re-fetches the full truck details to refresh all derived state.
 *   3. Clears the CTP pin assignments from the store.
 *
 * These side-effects were previously handled inside the thunk's `.then()`
 * callback. Moving them here keeps `actions/truck.js` declarative and
 * co-locates all async orchestration in the saga layer.
 */
export default function* watchVehicleReferenceParametersSaved() {
  yield takeEvery(VEHICLE_REFERENCE_PARAMETERS_SAVED, handleSaveSuccess)
}

/**
 * Named export for testing — drives the handler directly without going through
 * the watcher. Not part of the public saga API.
 */
export { handleSaveSuccess as handleSaveSuccessForTesting }

function* handleSaveSuccess({ serialNumber }) {
  // serialNumber flows in via ...args spread from the apiAction call site in
  // actions/truck.js (saveVehicleReferenceParameters). In production it is
  // always present, but guard here so a test that dispatches
  // VEHICLE_REFERENCE_PARAMETERS_SAVED without args does not silently fire
  // getTruckDetails({ serialNumber: undefined }) → GET /vehicles/undefined/...
  if (!serialNumber) return
  yield put(
    createSystemNotification({
      notificationMessage: strings.vehicle_updated,
    })
  )
  yield put(getTruckDetails({ serialNumber }))
  yield put({ type: CLEAR_PIN_ASSIGNMENTS })
}
